import {
  Card,
  Input,
  Header,
  Button,
  success,
  useUpload,
  ErrorAlert,
  SwitchInput,
  useFetchData,
  useCustomForm,
  UploadImageCard,
} from "@";
import { defaultValues, schema } from "./utils/validation";
import { generalSettingsFillForm } from "./utils/helpers";
import { getGeneralSettings, saveGeneralSettings } from "./utils/api";

const Index = () => {
  // Breadcrumb links
  const links = [
    { name: "الاعدادات", link: "/all-settings" },
    { name: "الاعدادات العامة", link: "" },
  ];

  // Form handling
  const {
    reset,
    watch,
    errors,
    setValue,
    register,
    handleSubmit,
    isSubmitting,
    isSubmitSuccessful,
  } = useCustomForm(defaultValues, schema);

  // Fetch data and handle errors
  const { error, fetchData } = useFetchData({
    reset: reset,
    fun: getGeneralSettings,
    fill: generalSettingsFillForm,
  });

  // Handle image upload
  const { handleUpload } = useUpload(setValue);

  // Form submission handler
  const submit = async (data) => {
    try {
      await saveGeneralSettings(data);
      success("تم التعديل بنجاح");
      fetchData();
    } catch (error) {}
  };

  return (
    <>
      {/* Error alert */}
      <ErrorAlert reload={fetchData} show={error} />
      <Header links={links} title="الاعدادات" />

      {/* Page content */}
      <form onSubmit={handleSubmit(submit)}>
        <div className="grid gap-x-5 lg:grid-cols-2">
          <Card title="إعدادت عامة" className="lg:col-span-2">
            <div className="grid gap-5 lg:grid-cols-2">
            
              {/* Name mandatory while login */}
              <SwitchInput
                label="الاسم اجباري عند التسجيل"
                checked={watch("NameMandatoryWhileLogin")}
                change={(value) => setValue("NameMandatoryWhileLogin", value)}
                isBordered={true}
              />

              {/* Enable WhatsApp chat */}
              <SwitchInput
                label="عرض ايقونة محادثة واتساب"
                checked={watch("EnableWhatsAppChat")}
                change={(value) => setValue("EnableWhatsAppChat", value)}
                isBordered={true}
              />

              {/* Show Apple Pay message */}
              <SwitchInput
                label="عرض رسالة ابل باي في الموقع"
                checked={watch("ShowApplePayMessage")}
                change={(value) => setValue("ShowApplePayMessage", value)}
                isBordered={true}
              />

            

              {/* send sms verification when login at website */}
              <SwitchInput
                label=" التحقق عن طريق ال SMS لتسجيل الدخول"
                checked={watch("SmsVerificationWhenLogin")}
                change={(value) => setValue("SmsVerificationWhenLogin", value)}
                isBordered={true}
              />
            </div>
          </Card>

          <Card title="اعدادات التبرعات">
            <div className="grid gap-5 lg:grid-cols-1">
               {/* Enable fast donation */}
               <SwitchInput
                label="تفعيل التبرع السريع"
                checked={watch("EnableFastDonation")}
                change={(value) => setValue("EnableFastDonation", value)}
                isBordered={true}
              />

                {/* Hide bank account from donation */}
                <SwitchInput
                label="اخفاء قائمة الحسابات البنكية من قائمة التبرع"
                checked={watch("HideBankAccountFromDonation")}
                change={(value) =>
                  setValue("HideBankAccountFromDonation", value)
                }
                isBordered={true}
              />

              {/* Minimum amount for donations */}
              <Input
                star
                label=" الحد الأدنى لإجمالي التبرعات"
                input={register("MinAmountForDonations")}
                error={errors?.MinAmountForDonations}
                description="
                يمثل الحد الأدنى لإجمالي التبرعات في  السلة بحيث لا يمكن للمستخدم التبرع إلا إذا كان المبلغ الإجمالي للتبرعات في السلة يساوي أو أكثر من هذا الرقم
                "
              />

              {/* Minimum amount for fast donation */}
              <Input
                star
                label=" الحد الأدنى للتبرع السريع"
                input={register("MinAmountForFastDonation")}
                error={errors?.MinAmountForFastDonation}
              />
              {/* Motivational sentence */}
              <Input
                star
                label=" الجملة التحفيزية"
                input={register("MotivationalSentence")}
              />
            </div>
          </Card>

        <Card title="الصور">
          <div className="grid gap-5 lg:grid-cols-2">
            {/* Complete project logo */}
            <UploadImageCard
              show
              success={isSubmitSuccessful}
              title="صورة اكتمال المشروع"
              src={watch("CompleteProjectLogoLink")}
              upload={(file) => handleUpload(file, "CompleteProjectLogoUrl")}
            />

            {/* Website main banner */}
            <UploadImageCard
              show
              success={isSubmitSuccessful}
              title="صورة البانر الرئيسي للموقع"
              src={watch("WebsiteMainBannerLink")}
              upload={(file) => handleUpload(file, "WebsiteMainBanner")}
            />

            {/* Website logo */}
            <div className="lg:col-span-2">
            <UploadImageCard
              show
              success={isSubmitSuccessful}
              title="شعار الموقع"
              src={watch("WebsiteLogoLink")}
              upload={(file) => handleUpload(file, "WebsiteLogoUrl")}
               
            />
            <p className="text-gray-500 mt-1 text-xs"> الصورة الموصى بها للشعار الموقع هي صورة مربعة 1:1
              (64px × 64px) او 
              
              في حالة الشعارات المستطيلة ينصح بالحجم 1:2 (110px × 64px)
              </p>
            </div>
          </div>
        </Card>
        </div>

        {/* Submit button */}
        <Button isLoading={isSubmitting} type="submit" title="حفظ الاعدادات" />
      </form>
    </>
  );
};
export default Index;
